import React from "react";
import useQuestion5 from "./hook";

const FifthQuestion = () => {
    const {
        user,
        selectedResponse,
        selectRes
    } = useQuestion5();

    return (
        <React.Fragment>
            {
                user.gender === "Female" ? (
                    // eslint-disable-next-line
                    <img
                        src="/images/quinta5.1.jpg"
                        alt="Background Image Question 1"
                        className="background-question-1"
                    />
                ) : (
                    // eslint-disable-next-line
                    <img
                        src="/images/quinta5.jpg"
                        alt="Background Image Question 1"
                        className="background-question-1"
                    />
                )
            }
            {
                user.gender === "Female" ? (
                    <React.Fragment>
                        <div className="true-response-5" onClick={() => selectedResponse(true, 'first')}>
                            {
                                selectRes.response && (
                                    <img src="/images/true-hover.png" alt="True Response Hover" />
                                )
                            }
                        </div>
                        <div className="false-response-5" onClick={() => selectedResponse(false, 'first')}>
                            {
                                selectRes.response === false && (
                                    <img src="/images/false-hover.png" alt="False Response Hover" />
                                )
                            }
                        </div>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <div className="true-response-5-men" onClick={() => selectedResponse(true, 'first')}>
                            {
                                selectRes.response && (
                                    <img src="/images/true-hover.png" alt="True Response Hover" />
                                )
                            }
                        </div>
                        <div className="false-response-5-men" onClick={() => selectedResponse(false, 'first')}>
                            {
                                selectRes.response === false && (
                                    <img src="/images/false-hover.png" alt="False Response Hover" />
                                )
                            }
                        </div>
                    </React.Fragment>
                )
            }
        </React.Fragment>
    );
}

export default FifthQuestion;